import { render, staticRenderFns } from "./ClientEmailNotificationFormBookingConfirmation.vue?vue&type=template&id=1e90ca6e&"
import script from "./ClientEmailNotificationFormBookingConfirmation.vue?vue&type=script&lang=js&"
export * from "./ClientEmailNotificationFormBookingConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports